module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av447-0e93778b97fcb10a60a9c96d6cb969c4.jpg";